export default "__VITE_ASSET__S1HTDzM3__"